import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { MOBILE_MEDIA_QUERY } from '../../../config/constants';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { analytics } from '../../../services/analytics';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';

const MOBILE_TOP_OFFSET = 240;
const DESKTOP_TOP_OFFSET = 480;

export function useLobbyMainView({ coinType }: { coinType: CoinType }) {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const topOffset = isMobile ? MOBILE_TOP_OFFSET : DESKTOP_TOP_OFFSET;
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    return () => {
      document.body.classList.remove('scrolled');
      document.body.classList.remove('lobby_scroll_finished');
    };
  }, []);

  useEffect(() => {
    void analytics.sendEvent('lobby_page', {
      event_category: 'lobby_page',
      event_action: 'impression',
      lobby_type: coinType === 'GC' ? 'CC' : 'SC',
    });
  }, [coinType]);

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const offset = e.currentTarget.scrollTop;
      if (offset > 0 && offset < topOffset) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      if (offset > 0) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }

      if (offset >= topOffset) {
        document.body.classList.add('lobby_scroll_finished');
      } else {
        document.body.classList.remove('lobby_scroll_finished');
      }
    },
    [topOffset],
  );

  return { handleScroll, isScrolled };
}
